const MONTH_KEYS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const toJsDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const ts = value?.seconds ? value.seconds * 1000 : value;
  const date = new Date(ts);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatLocalizedMonthYear = ({ value, locale, translate }) => {
  const date = toJsDate(value);
  if (!date) return null;

  if (String(locale || "").toLowerCase().startsWith("rw") && typeof translate === "function") {
    const monthKey = MONTH_KEYS[date.getMonth()];
    const monthLabel = translate(`months.long.${monthKey}`, monthKey);
    return `${monthLabel} ${date.getFullYear()}`;
  }

  return date.toLocaleDateString(locale || undefined, {
    month: "long",
    year: "numeric",
  });
};
